export const P256_DID_PREFIX = new Uint8Array([0x80, 0x24])
export const SECP256K1_DID_PREFIX = new Uint8Array([0xe7, 0x01])
export const BASE58_MULTIBASE_PREFIX = 'z'
export const DID_KEY_PREFIX = 'did:key:'

export const P256_JWT_ALG = 'ES256'
export const SECP256K1_JWT_ALG = 'ES256K'
